import {Component, Inject, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
    })
export class FooterComponent {

    readonly currentYear: number = new Date().getFullYear();

    constructor(@Inject(PLATFORM_ID) private platformId: object) {
    }

    clickedImpressum(): void {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }

        document.getElementById('inner-pager')?.scrollIntoView({behavior: 'smooth'});
    }
}
